export default __webpack_public_path__ + "static/media/profilePic.e5f05581.jpg";